import { loadRemoteScript } from "@/utils/scriptLoader";
import type ExcelJS from "exceljs";

/**
 * 本地excel处理
 */
export async function getExcelJS() {
    if (import.meta.env.VITE_IS_QN) {
        // @ts-ignore
        return window.ExcelJS as typeof ExcelJS;
    }

    await loadRemoteScript("https://cdn.fahuoyi.com/assets/third/exceljs/4.2.1.js");

    // @ts-ignore
    return window.ExcelJS as typeof ExcelJS;
}

export type { ExcelJS };
